"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.squareRootBN = void 0;
const bn_js_1 = require("bn.js");
const squareRootBN = (n, closeness = new bn_js_1.BN(1)) => {
    // Assuming the sqrt of n as n only
    let x = n;
    // The closed guess will be stored in the root
    let root;
    // To count the number of iterations
    let count = 0;
    const TWO = new bn_js_1.BN(2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    while (count < Number.MAX_SAFE_INTEGER) {
        count++;
        // Calculate more closed x
        root = x.add(n.div(x)).div(TWO);
        // Check for closeness
        if (x.sub(root).abs().lte(closeness))
            break;
        // Update root
        x = root;
    }
    return root;
};
exports.squareRootBN = squareRootBN;
